import { useCallback } from 'react';
import JSZip from 'jszip';
import { toast } from "@/components/ui/sonner";
interface FileData {
  filename: string;
  data: Blob;
}

export const usePDFZipper = () => {

  const zipAndSave = useCallback( async ( files: FileData[], zipFilename: string ) => {
    if ( !files || files.length === 0 ) {
      toast.warning( "Nenhum arquivo para compactar" );
      return;
    }

    try {
      const zip = new JSZip();
      files.forEach( file => {
        if ( file.data ) {
          zip.file( file.filename, file.data );
        }
      } );

      if ( Object.keys( zip.files ).length === 0 ) {
        toast.warning( 'Nenhum PDF foi gerado para compactar.' );
        return;
      }

      const zipBlob = await zip.generateAsync( { type: 'blob' } );

      const link = document.createElement( 'a' );
      link.href = URL.createObjectURL( zipBlob );
      link.download = zipFilename;
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
      URL.revokeObjectURL( link.href );

    } catch ( error ) {
      console.error( "Error creating zip file:", error );

      toast.error( "Erro ao compactar arquivos", {
        description: "Não foi possível gerar o arquivo .zip."
      } );
    }
  }, [ toast ] );

  return { zipAndSave };
};
